import { CancelablePromise } from '@signageos/lib/dist/Promise/cancelable';
import { TimeoutError } from '@signageos/lib/es6/Timer/timeout';

export function cancelableRejectAfterTimeout(timeout: number, message?: string): CancelablePromise<void> {
	let resolveCallback: (value: unknown) => void | undefined;
	let timeoutId: ReturnType<typeof setTimeout> | undefined;

	const promise = new Promise<void>((resolve, reject) => {
		resolveCallback = resolve;
		timeoutId = setTimeout(() => reject(new TimeoutError(message)), timeout);
	}) as CancelablePromise<void>;

	promise.cancel = (reason?: string) => {
		clearTimeout(timeoutId);
		if (resolveCallback) {
			resolveCallback(reason);
		}
	};

	return promise;
}
